import { Button, Result } from 'antd';
import { useNavigate } from 'react-router';
import { useTypeSafeTranslation } from '../modules/hooks/useTypeSafeTranslation';

const ErrorPage = () => {
  const { t } = useTypeSafeTranslation();
  const navigate = useNavigate();
  return (
    <Result
      status="500"
      title="500"
      subTitle={t('errorPage.subTitle')}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('errorPage.backHome')}
        </Button>
      }
    />
  );
};

export default ErrorPage;
